import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Grid from '~/truck/grid'
import theme from '~/truck/theme'

export const Container = styled.form`
  display: flex;
  flex-direction: column;

  > h3 {
    margin-bottom: ${theme.spacing.cozy * 4}px;
  }

  > h4 {
    margin: ${theme.spacing.cozy * 4}px 0;
  }

  > h4:first-of-type {
    margin-top: 0;
  }

  textarea {
    resize: vertical;
  }
`

const StyledColumn = styled(Grid.Column)`
  margin: 0;

  :not(:last-child) {
    margin-bottom: ${theme.spacing.comfortable}px;
  }

  ${up('lg')} {
    ${props =>
      props.marginToRight &&
      `
      margin-right: ${theme.spacing.comfortable}px;
    `}
  }
`

export const StyledGrid = styled(Grid)`
  padding: 0;

  > ${StyledColumn} {
    max-width: unset;
  }
`

StyledGrid.Column = StyledColumn
